(function () {
  const DRAWER_ID = 'Details-menu-drawer-container';
  const LOCK_CLASSES = ['overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden'];

  function unlockScroll() {
    LOCK_CLASSES.forEach((c) => {
      document.body.classList.remove(c);
      document.documentElement.classList.remove(c);
    });
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.height = '';
    document.body.style.top = '';
    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
  }

  function lockScroll() {
    document.body.classList.add('overflow-hidden-mobile');
  }

  function syncFromDetails() {
    const details = document.getElementById(DRAWER_ID);
    if (!details) {
      unlockScroll();
      return;
    }
    if (details.hasAttribute('open')) {
      lockScroll();
    } else {
      unlockScroll();
    }
  }

  function init() {
    const details = document.getElementById(DRAWER_ID);
    // Always start unlocked
    unlockScroll();

    if (details) {
      // Sync on every open/close event from the <details> element
      details.addEventListener('toggle', syncFromDetails);

      // If a user clicks/taps anywhere that closes the drawer (e.g. a link inside), force-unlock just in case
      details.addEventListener('click', (e) => {
        const link = e.target.closest('a[href]');
        if (link) {
          // Link navigation will close the page; pre-emptively clear locks
          unlockScroll();
        }
      });
    }

    // Defensive: re-sync whenever the page becomes visible / focus returns / pageshow (back-button)
    document.addEventListener('visibilitychange', () => { if (!document.hidden) syncFromDetails(); });
    window.addEventListener('pageshow', syncFromDetails);
    window.addEventListener('focus', syncFromDetails);

    // ESC key closes drawer — make sure scroll unlocks
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const d = document.getElementById(DRAWER_ID);
        if (d && d.hasAttribute('open')) {
          d.removeAttribute('open');
          unlockScroll();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
